import React, { memo } from 'react';

import { AttachmentItem } from '../AttachmentItem/AttachmentItem';
import { sortObjByField } from '../../../service/sort';
import { useDefects } from '../../../selectors/defects';
import { ContentType } from '../constants';
import { useStyles } from './useStyles';

export const Limitations = memo(() => {
    const defects = useDefects();
    const classes = useStyles();

    return (
        <>
            {defects.sort(sortObjByField('name')).map(({ id, isDownloaded, name }) => (
                <AttachmentItem
                    key={id}
                    contentType={ContentType.LIMITATIONS}
                    id={id}
                    isDownloaded={isDownloaded}
                    primaryText={name}
                    className={classes.nested} />
            ))}
        </>
    );
});

Limitations.displayName = 'Limitations';
